import { useState, useEffect } from 'react';
import { FetchRequestTypes, useFetch } from '../../../hooks/useFetch';
import { ArrivalsData, ArrivalsDataItem } from '../interfaces/arrivalsDepartures.interfaces';
import dayjs from 'dayjs';

export const useArrivalData = (refresh: boolean, loadMore: boolean, dateSpan: Date[] | undefined) => {
  const [arrivalsUrl, setArrivalsUrl] = useState<string | null>(null);
  const [arrivalsData, setArrivalsData] = useState<ArrivalsData | null>(null);
  const [arrivalsList, setArrivalsList] = useState<ArrivalsDataItem[]>([]);
  const [noMoreToLoad, setNoMoreToLoad] = useState(false);

  const excludedImoNumbers = [
    '9864277',
    '9131199',
    '9200158',
    '9333917',
    '9390458',
    '9236315',
    '9346641',
    '8327105',
    '9631436',
    '9327475',
    '9327487',
    '9254977',
    '9407225',
    '9318230',
    '8412235'
  ];

  const {
    data: arrivalsLoadedData,
    loading: arrivalsLoading,
    error: arrivalsError,
  } = useFetch(arrivalsUrl, FetchRequestTypes.GET);

  const itemsToLoad = 20;

  useEffect(() => {
    if (refresh) {
      setArrivalsList([]);
      setArrivalsData(null);
      setNoMoreToLoad(false);

      if (!dateSpan) {
        const today = dayjs().hour(0).minute(0).toISOString();
        setArrivalsUrl(`/api-aad/web-backend/v1/arrival?sortOrder=ASC&count=${itemsToLoad}&from=${today}`);
      } else {
        const from = dayjs(dateSpan[0]).hour(0).minute(0).second(0).toISOString();
        const to = dayjs(dateSpan[1]).hour(23).minute(59).second(59).toISOString();

        setArrivalsUrl(`/api-aad/web-backend/v1/arrival?sortOrder=ASC&count=250&from=${from}&to=${to}`);
      }
    }
  }, [refresh]);

  useEffect(() => {
    if (loadMore && !noMoreToLoad) {
      const continuationToken = (arrivalsLoadedData as ArrivalsData)?.continuationToken || '';
      setArrivalsUrl(
        `/api-aad/web-backend/v1/arrival?sortOrder=ASC&count=${itemsToLoad}&continuationToken=${continuationToken}`
      );
    }
  }, [loadMore]);

  useEffect(() => {
    if (arrivalsLoadedData?.items?.length) {
      //set items but exclude port control
      const listItems = (arrivalsLoadedData as ArrivalsData).items;

      const filteredListItems = listItems
        .filter((item) => item.name.toLowerCase() !== 'portcontrol' && item.name.toLowerCase() !== 'port control')
        .filter((item) => !excludedImoNumbers.some((exclImo) => item.imo === exclImo));

      setArrivalsData(arrivalsLoadedData);

      if (loadMore) {
        setArrivalsList([...arrivalsList, ...filteredListItems]);
      } else {
        setArrivalsList([...filteredListItems]);
      }

      setArrivalsUrl(null);
      if (!arrivalsLoadedData.continuationToken) {
        setNoMoreToLoad(true);
      }
    }
  }, [arrivalsLoadedData]);

  useEffect(() => {}, [arrivalsLoading, arrivalsError]);

  return {
    arrivalsList,
    noMoreToLoad,
    arrivalsLoading,
    arrivalsError,
  };
};

